import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
// import { saveAs } from "file-saver";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { ConfirmationService, MessageService } from "primeng/api";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
import * as moment from "moment";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Dropdown } from "primeng/dropdown";
import { Subject } from "rxjs/Rx";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-m-doc-repository",
    templateUrl: "./m-doc-repository.component.html",
    styleUrls: ["./m-doc-repository.component.css"],
    providers: [ConfirmationService, MessageService]
})
export class MDocRepositoryComponent implements OnInit {
    loading: boolean = false
    showGeneratePopup = false;
    badges = this.service.getStatusBadges();
    rowsNo = 10;
    offset: number = 0;
    pageSize: number = 10;
    noOfRecords: number = 0;
    hasSearched = false;
    sortField: String = "dateTimeReceived";
    sortOrder: number = -1;
    directionArray = [{ label: "Select", value: "-1" }, { label: "Inbound", value: "Inbound" }, { label: "Outbound", value: "Outbound" }]
    loader: boolean;
    valueType: string = "text"
    document: any = {};
    partnerArray: any = [];
    selected;
    noRecords: boolean = false;
    statusArray = [];
    ackStatusArray = [];
    correlationArray = [];
    public count = 0;
    public show: boolean = false;
    public show1: boolean = false;
    searchData: any = [];
    transactionArray = [];
    warehousesArray = [];
    parentWarehousesArray = [];
    display: boolean;
    detailInfoData: any = {};
    userRole: string;
    tableHeaders: { field: string; header: string; width: string; }[];
    correlationTypeDirection: boolean;
    correlationTypeDirection1: boolean;
    valueType1: string;
    correlationTypeDirection2: boolean;
    valueType2: string;
    selectedRow: any;
    depositorOrderNumber: any = " ";
    database: any;
    islifecycle: any;
    mailPopup: boolean;
    roleId: any;
    postTransFilePath: any = [];
    displayPostTransDownload: boolean;
    mulPostTransData: any = [];
    disableDownload: boolean = false;
    instanceId: any;
    correlationKeyArray: any = []
    displayPreTranslation: boolean;
    previewTranslation: any;
    filePath: any;
    htmlPreviewUrl!: SafeResourceUrl;
    deliveryList: any[];
    displayFilesModal: boolean;
    selectedFile: string | null = null;
    multipleFiles: any[] = [
        { key: 'Pre Translation', value: 'Pre Translation' },
        { key: 'Post Translation', value: 'Post Translation' },
        // {key: 'B2B',value: 'B2B'},
        // {key: 'VAN',value: 'VAN'}
    ]
    sapIdList: any = []
    @ViewChild('sapID', { static: false }) sapID!: Dropdown;


    constructor(
        private service: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        public datepipe: DatePipe,
        private router: Router,
        public activatedRoute: ActivatedRoute,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        private messageService: MessageService
    ) {

    }


    closePopup() {
        this.showGeneratePopup = false;
    }

    goToExports() {

        this.router.navigate(["mscvp/xl-downloads", { from: "mscvp/m-doc-repository" }])

    }
    alwaysShowCalendars: boolean;
    ranges: any = {
        'Today': [moment().startOf('day'), moment().endOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
        'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
        'Last Month': [
            moment().subtract(1, 'month').startOf('month').startOf('day'),
            moment().subtract(1, 'month').endOf('month').endOf('day')
        ]
    };


    ngOnInit() {
        this.getDropdownOptions();
        this.getStatus();
        this.userRole = this.session.retrieve("userRole");
        this.roleId = this.session.retrieve("UserDetails").roleId;
        this.islifecycle = this.activatedRoute.snapshot.paramMap.get("isback");
        this.tableHeaders = [
            { field: "", header: "#", width: "50px" },
            { field: "dateTimeReceived", header: "Date Time", width: "140px" },
            { field: "fileId", header: "Instance Id", width: "100px" },
            { field: "sapId", header: "SAP Id", width: "100px" },
            { field: "primaryKeyValue", header: "Document #", width: "200px" },
            { field: "parentWarehouse", header: "Division", width: "130px" },
            { field: "warehouse", header: "Warehouse", width: "150px" },
            { field: "partnerName", header: "Partner", width: "160px" },
            { field: "transactionType", header: "Transaction #", width: "120px" },
            { field: "isaControlNumber", header: "ISA CTRL", width: "100px" },
            { field: "direction", header: "Direction", width: "100px" },
            { field: "fileType", header: "File Format", width: "100px" },
            { field: "ackStatus", header: "ACK/API Status", width: "130px" },
            { field: "reProcessStatus", header: "Reprocess", width: "120px" },
            // { field: "deliveredTo", header: "DeliveredTo", width: "120px" },
        ];
        if (!this.islifecycle) {
            this.setToDefault();
        } else {
            this.setWarehouseLifecycle();
        }
    }

    //For server side pagination and sorting
    onPagination(data) {
        this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
        //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
        if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
            this.offset = data.first;
            this.pageSize = data.rows;
            this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
            this.sortField = data.sortField;
            this.sortOrder = data.sortOrder;
            this.search();
        }
    }
    setWarehouseLifecycle() {
        let document = this.localstorage.retrieve("document");
        this.document = document;
        let fromDate = new Date(this.document.fromDate);
        let toDate = new Date(this.document.toDate);
        this.dbChange("M", this.document.database);
        this.selected = {
            startDate: new Date(
                fromDate.getFullYear(),
                fromDate.getMonth(),
                fromDate.getDate(),
                fromDate.getHours(),
                fromDate.getMinutes(),
                fromDate.getSeconds(),
            ),
            endDate: new Date(
                toDate.getFullYear(),
                toDate.getMonth(),
                toDate.getDate(),
                toDate.getHours(),
                toDate.getMinutes(),
                toDate.getSeconds(),
            ),
        };

        this.document.partnerName = document.partnerName;
        this.document.receiverId = document.receiverId;
        this.search(true);
    }
    populated(data) {
        this.database = this.document.database;
        this.depositorOrderNumber = data.shipmentId;
        this.selectedRow = data;
    }
    reprocess() {
        const data = {
            "id": this.selectedRow.id
        }
        // reprocessFile
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(
                environment.apiUrl +
                "/documentRepository/ReprocessRequest", data,
                { headers: headers }
            )
            .subscribe((data) => {
                this.search();
            });
    }
    addFilter() {
        if (this.count == 0) {
            this.show = true;
            this.count = this.count + 1;
        } else if (this.count == 1) {
            this.show1 = true;
            this.show = true;
            this.count = this.count + 1;
        } else {
            alert("Limit exceeded... can't add more filters");
        }
    }
    warehouseLifecycle() {
        if (this.depositorOrderNumber == " " || this.database == " ") {
            alert("please select one check box");
        } else {
            this.localstorage.store("database", this.database);
            this.localstorage.store(
                "depositorOrderNumber",
                this.depositorOrderNumber
            );
            // this.router.navigate(["warehouse-lifecycle", { from: "mscvp/m-doc-repository" }]);
            this.router.navigate(["/mscvp/warehouse-lifecycle", { from: "mscvp/m-doc-repository" }]);
        }

    }
    removeFilter() {
        this.document.corrAttribute1 = "-1";
        this.document.corrValue1 = "";
        if (this.count == 2) {
            this.show = false;
            this.count = this.count - 1;
        } else if (this.count == 1) {
            this.document.corrAttribute2 = "-1";
            this.document.corrValue2 = "";
            this.show1 = false;
            this.show = false;
            this.count = this.count - 1;
        } else {
            alert("Limit exceeded... cannot remove more feilds");
        }
    }

    search(countFlag = false) {
        let abc = { ...this.document }
        let { limit, offSet, ...a } = abc
        console.log(abc)
        this.loader = true;
        this.searchData = [];
        this.document.flag = "search";
        if (
            this.document.corrAttribute != "-1" &&
            (this.document.corrValue == "" || this.document.corrValue == "-1")
        ) {
            this.loader = false;
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute == "-1" &&
            this.document.corrValue != ""
        ) {
            this.loader = false;
            alert("Please select Correlation !!");
            return false;
        }
        if (
            this.document.corrAttribute1 != "-1" &&
            this.document.corrValue1 == "" || this.document.corrValue1 == "-1"
        ) {
            this.loader = false;
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute1 == "-1" &&
            this.document.corrValue1 != ""
        ) {
            this.loader = false;
            alert("Please select Correlation !!");
            return false;
        }
        if (
            this.document.corrAttribute2 != "-1" &&
            this.document.corrValue2 == "" || this.document.corrValue2 == "-1"
        ) {
            this.loader = false;
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute2 == "-1" &&
            this.document.corrValue2 != ""
        ) {
            this.loader = false;
            alert("Please select Correlation !!");
            return false;
        }
        this.document.fromDate = this.datepipe.transform(
            this.selected.startDate,
            "MM/dd/yyyy HH:mm"
        );
        this.document.toDate = this.datepipe.transform(
            this.selected.endDate,
            "MM/dd/yyyy HH:mm"
        );
        this.document.limit = this.pageSize;
        this.document.offSet = this.offset;
        this.document.sortField = this.sortField;
        this.document.sortOrder = this.sortOrder == 1 ? "ASC" : "DESC";
        //To get list of partner names from array of objects
        let selectedPartners: any = []
        this.document.partnerName.map((e) => {
            selectedPartners.push(e.value)
        })
        let reqBody = { ...this.document };
        reqBody.parentFileId = '-1'
        // reqBody.corrAttribute = reqBody.corrAttribute === 'pri_key_type' ? 'Pri Key Type' : reqBody.corrAttribute
        // reqBody.corrAttribute1 = reqBody.corrAttribute1 === 'sec_key_type' ? 'Sec Key Type' : reqBody.corrAttribute1
        reqBody.partnerName = this.service.multiSelectValue(this.partnerArray, selectedPartners);
        reqBody.parentWarehouse = this.service.multiSelectValue(this.parentWarehousesArray, reqBody.parentWarehouse);
        // reqBody.ackStatus = this.service.multiSelectValue(this.ackStatusArray, reqBody.ackStatus);
        // reqBody.warehouse = this.service.multiSelectValue(this.warehousesArray, reqBody.warehouse);
        reqBody.warehouse = reqBody.warehouse != '' ? [reqBody.warehouse] : reqBody.warehouse
        reqBody.countFlag = true
        let headers = new HttpHeaders();
        this.hasSearched = true;
        // let token="Bearer eyJhbGciOiJIUzUxMiJ9.eyJpc0FsbFBhcnRuZXJzVmlzaWJsZSI6IltdIiwidGltZVpvbmUiOiItMDY6MDAiLCJpZCI6IjQwNCIsInVzZXJuYW1lIjoiT1ZFenRyQlNRWW5PT3doZ0lXOGlPRTMwaGRUT09Wa1VNY0JhY0pleXgwSy91blc2ZWFxYVZTc3FJOUkveC8xd09TRndjTXRjaDgyTzRNdlhNb0R1YVBjV1JYaDVwZExnQkgxMStYTUxESm5BZk96NXB0UkdieGFFajdLbU12ODdOdkNrbzNpaHJTbWRKakNoQ0Z4Z3M5c0Z1UGw0RW9OdzgvZWZSUkxrK0VFb2szd3BNQk4xUUVxamtKZDJoM1NzeFJ3dzRDK2YwR205RUx5dFFiTXJBNTJyT0dMMWsyNkgrNnRtc3JZd25YL29HbWQ3M3l0cFZmK01Vb0F0R1RPTVZYWDFuN21MdkV5RU9FOFBOd2loMHQyaVlZWW9OV09ad1FFdnpMSi9ITVE2VUVYRjZja3dqeFlBOWpFakhGdFQyeThqZ2lkVGE3SjE2S2IrNVBpR3RBPT0iLCJzdWIiOiJ7XCJpc0FsbFBhcnRuZXJzVmlzaWJsZVwiOlwiW11cIixcInRpbWVab25lXCI6XCItMDY6MDBcIixcImlkXCI6XCI0MDRcIixcInVzZXJuYW1lXCI6XCJPVkV6dHJCU1FZbk9Pd2hnSVc4aU9FMzBoZFRPT1ZrVU1jQmFjSmV5eDBLL3VuVzZlYXFhVlNzcUk5SS94LzF3T1NGd2NNdGNoODJPNE12WE1vRHVhUGNXUlhoNXBkTGdCSDExK1hNTERKbkFmT3o1cHRSR2J4YUVqN0ttTXY4N052Q2tvM2loclNtZEpqQ2hDRnhnczlzRnVQbDRFb053OC9lZlJSTGsrRUVvazN3cE1CTjFRRXFqa0pkMmgzU3N4Und3NEMrZjBHbTlFTHl0UWJNckE1MnJPR0wxazI2SCs2dG1zcll3blgvb0dtZDczeXRwVmYrTVVvQXRHVE9NVlhYMW43bUx2RXlFT0U4UE53aWgwdDJpWVlZb05XT1p3UUV2ekxKL0hNUTZVRVhGNmNrd2p4WUE5akVqSEZ0VDJ5OGpnaWRUYTdKMTZLYis1UGlHdEE9PVwifSIsImlhdCI6MTc4MjczMTQyOCwiZXhwIjoxNzgyNzYwMjI4fQ.LydfYilGv5RcwPGtN2USS1_GmV_rnIFQog104fsjoavBjJGiT52vrGaVjrh21Eweb5QptKs7h8BEw2dgGj3gNQ"
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
            // token
        );
        console.log(reqBody, "====req", this.correlationArray);
        this.http
            .post(
                environment.apiUrl + "/documentRepository/search", { ...reqBody, countFlag },
                {
                    headers: headers,
                }
            )
            .subscribe((data: any) => {
                // //console.log(data,"====");                
                this.loader = false;
                this.localstorage.store("document", this.document);
                this.searchData = data.data;
                if (countFlag) {
                    this.noOfRecords = data.totalRecordsCount;
                }
                if (data.totalRecordsCount == 0) {
                    this.noRecords = true;
                }
            });
    }

    detailInfo(id, database, instanceId) {
        this.instanceId = instanceId;
        this.display = true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(
                environment.apiUrl +
                "/documentRepository/detailInfo/" +
                id +
                "/" +
                database,
                { headers: headers }
            )
            .subscribe((data) => {
                this.detailInfoData = data;
                //For extracting multiple file paths 
                this.postTransFilePath = this.detailInfoData.postTransFilePath.split(',')
            });
    }

    export() {
        this.disableDownload = true;
        this.document.flag = "excel";
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
            // token
        );
        let selectedPartners: any = []
        this.document.partnerName.map((e: any) => {
            selectedPartners.push(e.value)
        })
        let { limit, offSet, ...reqBody } = this.document;
        reqBody.partnerName = this.service.multiSelectValue(this.partnerArray, selectedPartners);
        reqBody.parentWarehouse = this.service.multiSelectValue(this.parentWarehousesArray, reqBody.parentWarehouse);
        reqBody.warehouse = Array.isArray(reqBody.warehouse) ? reqBody.warehouse : [reqBody.warehouse];
        console.log(reqBody.warehouse, "The reqBody parentWarehouse");

        reqBody.countFlag = false;
        this.showGeneratePopup = true;
        this.service.postReportDownload(reqBody, headers)
            .subscribe(
                (response: any) => {

                    this.disableDownload = false;
                    // var blob = new Blob([response], {
                    //     type: "application/vnd.ms-excel",
                    // });
                    // saveAs(
                    //     blob,
                    //     "DocumentRepositoryReport_" +
                    //     this.datepipe.transform(this.service.getDateByTZ(), "ddMMyyyy_HHmm", "+0000") +
                    //     ".xlsx"
                    // );
                    console.log(response)
                   
                },
                (error) => {
                    this.disableDownload = false;
                    console.log("Error occured" + error);
                }
            );
    }

    translationFileDownload(filePath) {
        // this.service.translationFileDownload(filePath);
        // this.loader = true   
        this.filePath = filePath;
        this.service.translationFilePreview(filePath).subscribe((data: any) => {
            this.loader = false
            if (filePath.endsWith('.html')) {
                const blob = new Blob([data], { type: 'text/html' });
                const url = URL.createObjectURL(blob);
                this.htmlPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                this.displayPreTranslation = true;
            } else {
                this.previewTranslation = data;
                this.displayPreTranslation = true;
            }
        });
    }

    download() {
        this.service.translationFileDownload(this.filePath);
    }

    setDefaultPagination() {
        this.hasSearched = false;
        this.offset = 0;
        this.pageSize = 10;
        this.noOfRecords = 0;
        this.sortField = "dateTimeReceived";
        this.sortOrder = -1;
    }
    setToDefault() {
        this.setDefaultPagination();
        this.noRecords = false;
        this.document.database = "LIVE";
        let today = this.service.getDateByTZ();
        this.selected = {
            startDate: new Date(
                today.getUTCFullYear() || new Date().getUTCFullYear(),
                today.getUTCMonth() || new Date().getUTCMonth(),
                today.getUTCDate() || new Date().getUTCDate(),
                0,
                0,
                0
            ),
            endDate: new Date(
                today.getUTCFullYear() || new Date().getUTCFullYear(),
                today.getUTCMonth() || new Date().getUTCMonth(),
                today.getUTCDate() || new Date().getUTCDate(),
                23,
                59,
                0
            ),
        };
        this.dbChange("M", this.document.database);
        this.count = 0;
        this.show = false;
        this.show1 = false;
        this.document.transactionType = "-1";
        this.document.partnerName = [];
        this.document.parentWarehouse = [];
        this.document.ackStatus = -1;
        this.document.warehouse = [];
        this.document.status = "-1";
        this.document.corrAttribute = "-1";
        this.document.corrAttribute1 = "-1";
        // this.document.corrAttribute2 = "-1";
        this.document.deliveredTo = "-1";
        this.document.corrValue = "";
        this.document.corrValue1 = "";
        this.searchData = [];
        this.document.documentNumber = "";
        this.document.direction = '-1';
        this.document.sapId = '';
        this.sapID.resetFilter();

    }
    //This method is used to get Status, Ack Status, Correlation dropdown options
    getDropdownOptions() {
        // this.statusArray = this.service.getStatusDocRepo();
        // this.ackStatusArray = this.service.getAckAndApiStatus();
        // this.correlationArray = this.service.getcorrelation(
        //     this.localstorage.retrieve("token"),
        //     "All"
        // );
        // this.getStatus();
        // this.getCorrelation();
        // this.getTradingPartner();
        this.statusArray = this.service.getStatus();
        this.ackStatusArray = this.service.getAckAndApiStatus();
        this.correlationArray = this.service.getcorrelation(
            this.localstorage.retrieve("token"),
            "All"
        );
        this.getSAPIdList();
    }

    getSAPIdList() {
        this.service.getSAPIdsLookup().subscribe((res: any) => {
            const result = (res).map(item => ({ label: item, value: item }));
            this.sapIdList = [{ label: "Select", value: "" }, ...result];
        })
    }

    getStatus() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http.get(environment.apiUrl + "/utilities/status", { headers: headers })
            .subscribe((response: any) => {
                const result = (response).map(item => ({ label: item, value: item }));
                this.statusArray = [{ label: "Select", value: "" }, ...result];
                //console.log(response, "===response====");
            })
    }

    getPrimaryKey(data: any) {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http.get(environment.apiUrl + "/utilities/key-types?attribute=" + `${data}`, { headers: headers })
            .subscribe((response: any) => {
                const result = (response).map(item => ({ label: item, value: item }));
                this.correlationKeyArray = [{ label: "Select", value: "" }, ...result];
                //console.log(response, "===response====");
            })
    }

    getSecondaryKey(data: any) {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http.get(environment.apiUrl + "/utilities/key-types?attribute=" + `${data}`, { headers: headers })
            .subscribe((response: any) => {
                const result = response.map(item => ({ label: item, value: item }));
                this.correlationKeyArray = [{ label: "Select", value: "" }, ...result.map(option => ({ ...option }))];
                // this.correlationKeyArray1 = [{ label: "Select", value: "" }, ...result.map(option => ({ ...option }))];
                //console.log(response, "===response====");
            });
    }

    getCorrelation() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http.get(environment.apiUrl + "/utilities/Correlation", { headers: headers })
            .subscribe((response: any) => {
                const result = response.map(item => ({ label: item, value: item }));
                this.correlationArray = [{ label: "Select", value: "", disabled: false }];
                // this.correlationArray1 = [{ label: "Select", value: "", disabled: false }];    
                this.correlationArray.push(...result.map(option => ({
                    ...option,
                    // disabled: option.label !== "pri_key_type" 
                })));
                // this.correlationArray1.push(...result.map(option => ({
                //     ...option,
                //     disabled: option.label !== "sec_key_type" 
                // })));
            });
    }


    getTradingPartner() {
        let headers = new HttpHeaders();
        headers = headers.append("authorization", this.localstorage.retrieve("token"));
        this.http.get(environment.apiUrl + "/utilities/tradingPartnerName", { headers: headers })
            .subscribe((response: any) => {
                if (!response || response.length === 0) {
                    this.partnerArray = [];
                    return;
                }
                this.partnerArray = response.map(item => ({
                    label: item,  // Display name
                    value: item // Actual stored value
                }));
                //console.log("Fetched Partners:", this.partnerArray);
            }, error => {
                //console.error("Error fetching partners:", error);
            });
    }
    getDeliveryTo() {
        let headers = new HttpHeaders();
        headers = headers.append("authorization", this.localstorage.retrieve("token"));
        this.http.get(environment.apiUrl + "/utilities/deliveredTo", { headers: headers })
            .subscribe((response: any) => {
                if (!response || response.length === 0) {
                    this.deliveryList = [];
                    return;
                }
                this.deliveryList = response.map(item => ({
                    label: item,  // Display name
                    value: item // Actual stored value
                }));
                //console.log("Fetched Partners:", this.deliveryList);
            }, error => {
                //console.error("Error fetching partners:", error);
            });
    }
    dbChange(flowFlag, database) {
        this.transactionArray = this.service.getDocumentTypes(
            this.localstorage.retrieve("token"),
            flowFlag,
            database
        );
        //To get list of partners
        // this.service.getPartners(
        //     this.localstorage.retrieve("token"),
        //     flowFlag,
        //     database
        // ).subscribe((res) => {
        //     this.partnerArray = res;
        // })
        this.getTradingPartner();
        this.getDeliveryTo();
        this.parentWarehousesArray = this.service.getParentWarehouses(
            this.localstorage.retrieve("token"),
            flowFlag,
            database
        );
        this.getWarehousesForWms([], database)
    }
    getWarehousesForWms(parentWarehouse, database) {
        this.document.warehouse = [];
        this.warehousesArray = this.service.getWarehouses(
            this.localstorage.retrieve("token"),
            database,
            this.service.multiSelectValue(this.parentWarehousesArray, parentWarehouse)
        );
    }

    dwnldMultiFiles(event: any) {
        console.log('eve ', event);
        this.selectedFile = '';
        this.displayFilesModal = !this.displayFilesModal;
    }


    selectFile(fileValue: string) {
        this.selectedFile = fileValue;
    }

    downloadFiles() {
        if (!this.selectedFile) return;
        console.log('Download:', this.selectedFile);
        // Add your download logic here based on `selectedFile`
        this.displayFilesModal = false;
    }

    onStatusUpdate(rowData: any) {
        console.log('Updated Status:', rowData);
        const params = {
            id: rowData.id,
            reprocessStatus: rowData.reProcessStatus
        }
        console.log('params ', params);
        this.service.updateReProcessColumn(params).subscribe({
            next: (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: res.message
                });
                console.log('Status updated successfully', res);
            },
            error: (err) => {
                this.search(true);
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: 'Error updating status',
                });
                console.error('Error updating status', err);
            }
        });
    }
    setValueType() {
        this.document.corrValue = "";
        this.correlationTypeDirection = (this.document.corrAttribute == "Direction") ? true : false;
        this.valueType = (this.document.corrAttribute == "Instance Id" || this.document.corrAttribute == "ISA Number" || this.document.corrAttribute == "GS Number") ? "number" : "text";
        console.log(this.document.corrAttribute, this.correlationTypeDirection, this.document);

    }

    setValueType1() {
        this.document.corrValue1 = "";
        this.correlationTypeDirection1 = (this.document.corrAttribute1 == "Direction") ? true : false;
        this.valueType1 = (this.document.corrAttribute1 == "Instance Id") ? "number" : "text";
        console.log(this.document.corrAttribute1);

    }
    setValueType2() {
        this.document.corrValue2 = "";
        this.correlationTypeDirection2 = (this.document.corrAttribute2 == "Direction") ? true : false;
        this.valueType2 = (this.document.corrAttribute2 == "Instance Id") ? "number" : "text";
    }
    confirmReprocess() {
        if (this.depositorOrderNumber == " " || this.database == " ") {
            alert("please select one check box");
        } else {
            this.confirmationService.confirm({
                message: 'Are you sure that you want to reprocess?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                key: "positionDialog",
                accept: () => {
                    this.reprocess()
                },
                reject: () => {
                }
            });
        }
    }
    openMailDialog() {
        this.mailPopup = true;
    }
    updateDialog() {
        this.mailPopup = false
    }
    showMultipostTransDownload() {
        this.displayPostTransDownload = true
        this.mulPostTransData = [];
        this.postTransFilePath.map((data) => this.mulPostTransData.push({ path: data, isSelected: false }))
    }
    updateMultiFileDialog(data) {
        (data == "false") ? this.displayPostTransDownload = false : null;
    }
    //For showing loader on multiple post trans file download
    updateloaderVisibilty(data) {
        this.loader = data == "true" ? true : false;
    }
    ngOnDestroy(){

   

}

}